function Logout() {
  window.location.href = `${process.env.REACT_APP_REDIRECT}?logout=true`;
}

export default Logout;